import { Button } from '@cian/ui-kit/button';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './ListingDesktopFooter.css';

export interface IListingDesktopFooterProps {
  onPrevClick(): void;
  onNextClick(): void;
  hasPrev: boolean;
  hasNext: boolean;
  isLoading: boolean;
  className?: string;
}

export const ListingDesktopFooter: React.FC<IListingDesktopFooterProps> = ({
  onPrevClick,
  onNextClick,
  hasPrev,
  hasNext,
  isLoading,
  className,
}) => {
  const isPrevDisabled = !hasPrev || isLoading;
  const isNextDisabled = !hasNext || isLoading;

  return (
    <div data-testid="ListingDesktopFooter" className={cn(styles['root'], className)}>
      <div className={styles['nav-row']}>
        <div className={styles['nav-button']}>
          <Button
            onClick={onPrevClick}
            theme={isPrevDisabled ? 'main_primary' : 'stroke_primary'}
            disabled={isPrevDisabled}
            loading={isLoading}
            fullWidth
          >
            Назад
          </Button>
        </div>
        <div className={styles['nav-button']}>
          <Button
            onClick={onNextClick}
            theme={isNextDisabled ? 'main_primary' : 'stroke_primary'}
            disabled={isNextDisabled}
            loading={isLoading}
            fullWidth
          >
            Дальше
          </Button>
        </div>
      </div>
    </div>
  );
};

ListingDesktopFooter.displayName = 'ListingDesktopFooter';
